import React from 'react';
import {Card, Typography} from 'antd';
import {useTranslations} from '../../lang';
import LegalDocument from '../../Components/LegalDocument';
import legalDocuments from '../../legal/englishLegalDocuments.json';
import {getMarketForLocation} from '../../environment';

const {Title} = Typography;

export default function TermsOfService() {
    useTranslations();
    const market = getMarketForLocation(window.location.hostname, window.location.search);
    if (market === 'US') {
        return <LegalDocument document={legalDocuments.terms}/>;
    }
    return (
        <div style={{maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem'}}>
            <Card>
                <Title level={1}>Algemene Voorwaarden</Title>

                <div>

                    <p>Oogst.app is ingeschreven bij de Kamer van Koophandel onder nummer 61063304 en is gevestigd aan
                        Rijksstraatweg
                        55, 8121ED, Olst.</p>

                    <h2>Artikel 1 Begrippen</h2>

                    <p>1. In deze algemene voorwaarden worden de volgende termen met de bijbehorende betekenis gebruikt,
                        tenzij
                        uitdrukkelijk anders is aangegeven.
                        <br/>2. Aanbod: iedere aanbieding of offerte aan Opdrachtgever tot het verrichten van Diensten
                        door Oogst.app.
                        <br/>3. Bedrijf: de natuurlijke of rechtspersoon die handelt in de uitoefening van beroep of
                        bedrijf.
                        <br/>4. Consument: de natuurlijke persoon die niet handelt in de uitoefening van beroep of
                        bedrijf.
                        <br/>5. Diensten: de diensten die Oogst.app aanbiedt, waaronder het beschikbaar stellen van
                        software en
                        bijbehorende ondersteuning.
                        <br/>6. Dienstverlener: Oogst.app, opgericht naar Nederlands recht, gevestigd in Nederland, die
                        Diensten aan
                        Opdrachtgever aanbiedt, hierna: Oogst.app.
                        <br/>7. Opdrachtgever: Het Bedrijf of de Consument die Oogst.app heeft aangesteld, opdrachten
                        heeft verleend
                        voor Diensten die door Oogst.app worden uitgevoerd, of waaraan Oogst.app een voorstel op grond
                        van een
                        Overeenkomst heeft gedaan.
                        <br/>8. Overeenkomst: elke overeenkomst en andere verplichtingen tussen Opdrachtgever en
                        Oogst.app, alsmede
                        voorstellen van Oogst.app voor Diensten die door Oogst.app aan Opdrachtgever worden verstrekt en
                        die door
                        Opdrachtgever zijn aanvaard en geaccepteerd en uitgevoerd door Oogst.app, waar deze algemene
                        voorwaarden een
                        onverbrekelijk geheel van vormen.
                        <br/>9. SaaS-dienst: het op afstand beschikbaar stellen en houden van software, zonder dat aan
                        Opdrachtgever een
                        fysieke drager met de betreffende software wordt verstrekt.
                        <br/>10. Website: de website die toegang geeft tot de online diensten en software van Oogst.app
                        is
                        www.oogst.app.
                    </p>
                    <h2>Artikel 2 Toepasselijkheid</h2>

                    <p>1. Deze algemene voorwaarden zijn van toepassing op elk Aanbod van Oogst.app, elke Overeenkomst
                        tussen Oogst.app
                        en Opdrachtgever, en op elke Dienst die door Oogst.app wordt aangeboden.
                        <br/>2. Voordat een Overeenkomst wordt gesloten, krijgt Opdrachtgever de beschikking over deze
                        algemene
                        voorwaarden. Indien dit redelijkerwijs niet mogelijk is, zal Oogst.app aan Opdrachtgever
                        aangeven op welke wijze
                        Opdrachtgever de algemene voorwaarden kan inzien.
                        <br/>3. Afwijking van deze algemene voorwaarden is niet mogelijk, tenzij dit expliciet en
                        schriftelijk met
                        Oogst.app is overeengekomen.
                        <br/>4. Deze algemene voorwaarden zijn ook van toepassing op aanvullende, gewijzigde en
                        vervolgopdrachten van
                        Opdrachtgever.
                        <br/>5. De algemene voorwaarden van Opdrachtgever zijn uitdrukkelijk uitgesloten.
                        <br/>6. Indien een of meerdere bepalingen van deze algemene voorwaarden gedeeltelijk of geheel
                        nietig zijn of
                        worden vernietigd, blijven de overige bepalingen van deze algemene voorwaarden in stand. De
                        nietige of
                        vernietigde bepaling(en) worden vervangen door een bepaling met dezelfde strekking als de
                        originele bepaling.
                        <br/>7. Onduidelijkheden over de inhoud, uitleg of situaties die niet geregeld zijn in deze
                        algemene
                        voorwaarden, dienen beoordeeld en uitgelegd te worden naar de geest van deze algemene
                        voorwaarden. De afspraken
                        in de Overeenkomst zijn leidend, en gaan boven deze algemene voorwaarden.
                        <br/>8. De toepasselijkheid van de artikelen 7:404 BW en 7:407 lid 2 BW is expliciet
                        uitgesloten.
                        <br/>9. De rechten en verplichtingen uit de Overeenkomst tussen Partijen kunnen niet door
                        Opdrachtgever aan een
                        derde worden overgedragen, tenzij Oogst.app uitdrukkelijk en voorafgaand toestemming verleent.
                        Oogst.app kan aan
                        deze toestemming nadere voorwaarden verbinden.
                    </p>
                    <h2>Artikel 3 Het Aanbod</h2>

                    <p>1. Alle door Oogst.app gedane aanbiedingen zijn vrijblijvend, tenzij schriftelijk uitdrukkelijk
                        anders is
                        aangegeven.
                        <br/>2. Oogst.app is slechts aan een Aanbod gebonden indien de aanvaarding hiervan door
                        Opdrachtgever
                        schriftelijk wordt bevestigd.
                        <br/>3. Het Aanbod bevat een omschrijving van de aangeboden Diensten. De beschrijving is
                        dusdanig gedetailleerd
                        dat Opdrachtgever in staat is om een goede beoordeling van het Aanbod te maken.
                        <br/>4. Aanbiedingen gelden niet automatisch voor vervolgopdrachten.
                        <br/>5. Oplevertijden en termijnen in het aanbod van Oogst.app zijn indicatief en geven
                        Opdrachtgever bij
                        overschrijding ervan geen recht op ontbinding of schadevergoeding, tenzij uitdrukkelijk anders
                        is
                        overeengekomen.
                    </p>
                    <h2>Artikel 4 Totstandkoming van de Overeenkomst</h2>

                    <p>1. De Overeenkomst komt tot stand op het moment dat Opdrachtgever een Aanbod of Overeenkomst van
                        Oogst.app heeft
                        aanvaard door een ondertekend exemplaar aan Oogst.app te retourneren of door expliciet akkoord
                        per e-mail te
                        geven.
                        <br/>2. Elke Overeenkomst die met Oogst.app wordt aangegaan, berust bij het Bedrijf en niet bij
                        een individuele
                        persoon die met Oogst.app is verbonden.
                        <br/>3. Herroepingsrecht:

                    </p>
                    <ul style={{listStyleType: 'disc', paddingLeft: '40px', marginLeft: 0}}>

                        <li style={{listStyleType: 'disc'}}>Voor consumenten: Indien de Opdrachtgever een Consument is,
                            heeft deze het recht de Overeenkomst binnen 14 dagen zonder opgave van redenen te herroepen.
                            De herroepingstermijn verstrijkt 14 dagen na de dag waarop de Overeenkomst is aangegaan. Om
                            het herroepingsrecht uit te oefenen, moet de Consument Oogst.app via een ondubbelzinnige
                            verklaring (bijvoorbeeld schriftelijk per post, fax of e-mail) op de hoogte stellen van de
                            beslissing de Overeenkomst te herroepen. De Consument kan hiervoor gebruikmaken van het
                            modelformulier voor herroeping, maar is hiertoe niet verplicht.
                        </li>
                        <li style={{listStyleType: 'disc'}}>Gevolgen van herroeping: Als de Consument de Overeenkomst
                            herroept, ontvangt hij alle betalingen die hij tot op dat moment heeft gedaan, inclusief
                            leveringskosten (met uitzondering van eventuele extra kosten ten gevolge van de keuze van de
                            Consument voor een andere leveringswijze dan de door Oogst.app geboden goedkoopste
                            standaardlevering) onverwijld en in ieder geval niet later dan 14 dagen nadat Oogst.app op
                            de hoogte is gesteld van de beslissing van de Consument de Overeenkomst te herroepen, van
                            Oogst.app terug. Oogst.app betaalt de Consument terug met hetzelfde betaalmiddel als waarmee
                            de Consument de oorspronkelijke transactie heeft verricht, tenzij de Consument uitdrukkelijk
                            anderszins heeft ingestemd; in ieder geval zullen voor zulke terugbetalingen geen kosten in
                            rekening worden gebracht.
                        </li>
                        <li style={{listStyleType: 'disc'}}>Uitzonderingen: Indien de Consument uitdrukkelijk heeft
                            verzocht om met de uitvoering van de dienst aan te vangen tijdens de herroepingstermijn, is
                            de Consument een bedrag verschuldigd dat evenredig is aan hetgeen reeds is geleverd op het
                            moment dat Oogst.app de herroeping heeft ontvangen, vergeleken met de volledige uitvoering
                            van de Overeenkomst. Indien de volledige dienst reeds is geleverd binnen de
                            herroepingstermijn, verliest de Consument het herroepingsrecht.
                        </li>
                        <li style={{listStyleType: 'disc'}}>Voor bedrijven: Het herroepingsrecht is uitgesloten voor
                            Bedrijven, tenzij anders overeengekomen.
                        </li>
                    </ul>
                    <h2>Artikel 5 Duur van de Overeenkomst</h2>

                    <p>1. De Overeenkomst voor het uitvoeren van diensten wordt aangegaan in de vorm van een abonnement.
                        Een abonnement
                        wordt aangegaan in de vorm van een maandelijkse betaling of voor een periode van 12 maanden.
                        <br/>2. Het abonnement wordt bij een maandelijkse betaling telkens stilzwijgend verlengd met één
                        maand, tenzij
                        Opdrachtgever de Overeenkomst ten minste 1 dag voor het verstrijken van de desbetreffende
                        periode heeft
                        beëindigd.
                        <br/>3. Bij een jaarabonnement wordt na het verstrijken van de abonnementsperiode het abonnement
                        telkens
                        stilzwijgend verlengd met één jaar (12 maanden), tenzij Opdrachtgever de Overeenkomst ten minste
                            1 maand voor
                            het verstrijken van de periode heeft beëindigd.
                        <br/>Opdrachtgever kan automatische verlenging annuleren via de abonnementsinstellingen in het
                        account of per e-mail aan support@oogst.app. Een toepasselijke terugbetaling na een aankoop- of
                        herroepingsverzoek wordt onverwijld en uiterlijk binnen 14 dagen na dat verzoek betaald.
                        <br/>4. Zowel Opdrachtgever als Oogst.app kunnen de Overeenkomst ontbinden op grond van een
                        toerekenbare
                        tekortkoming in de nakoming van de Overeenkomst, indien de andere partij schriftelijk in gebreke
                        is gesteld, en
                        hem een redelijke termijn is gegeven om zijn verplichtingen na te komen, en hij hierin
                        toerekenbaar
                        tekortschiet.
                        <br/>5. De ontbinding van de Overeenkomst laat de betalingsverplichtingen van Opdrachtgever
                        onverlet indien
                        Oogst.app ten tijde van de ontbinding werkzaamheden heeft verricht of prestaties heeft geleverd.
                    </p>
                    <h2>Artikel 6 Uitvoering van de Overeenkomst</h2>
                    <p>
                        1. Oogst.app zal zich inspannen om de Overeenkomst met de grootst mogelijke zorgvuldigheid uit
                        te voeren zoals van een goed opdrachtnemer verlangd mag worden. Alle Diensten worden uitgevoerd
                        op basis van een inspanningsverbintenis, tenzij expliciet en schriftelijk een resultaat is
                        overeengekomen.
                        <br/>2. De door Opdrachtgever verstrekte informatie en gegevens vormen de basis waarop de door
                        Oogst.app aangeboden Diensten en prijzen zijn gebaseerd. Oogst.app heeft het recht haar
                        dienstverlening en prijzen aan te passen indien de verstrekte informatie onjuist en/of
                        onvolledig blijkt te zijn.
                        <br/>3. Opdrachtgever maakt een gebruikersnaam en wachtwoord aan voordat de betaling voor het
                        abonnement plaatsvindt. Nadat de betaling is verricht, wordt het account van Opdrachtgever
                        geactiveerd.
                        <br/>4. Oogst.app is gerechtigd om voor de uitvoering van de Diensten naar eigen inzicht derden
                        in te schakelen.
                        <br/>5. De broncode en technische documentatie van de software zijn te allen tijde uitgesloten
                        van het gebruiksrecht of overdracht aan Opdrachtgever.
                    </p>
                    <h2>Artikel 7 Garanties en Aansprakelijkheid</h2>
                    <p>
                        1. Oogst.app voert de Diensten uit conform de in de branche geldende normen. Indien enige
                        garantie is gegeven, is deze beperkt tot hetgeen uitdrukkelijk en schriftelijk is
                        overeengekomen.
                        <br/>2. Opdrachtgever kan slechts een beroep doen op de door Oogst.app gegeven garantie indien
                        Opdrachtgever volledig aan zijn betalingsverplichtingen heeft voldaan.
                        <br/>3. Oogst.app staat er niet voor in dat de software zonder fouten en/of onderbrekingen
                        functioneert. Oogst.app spant zich in om fouten binnen een redelijke termijn te herstellen.
                    </p>
                    <h2>Artikel 8 Gebruiksrecht en gebruiksbeperkingen</h2>
                <p>
                    1. Oogst.app stelt de overeengekomen software en gebruikersdocumentatie op basis van een
                    gebruikslicentie gedurende de looptijd van de Overeenkomst ter beschikking aan Opdrachtgever.
                    <br/>2. Het is Opdrachtgever verboden om de software te verkopen, verhuren, vervreemden, daarop
                    beperkte rechten te verlenen, of ter beschikking te stellen aan derden zonder voorafgaande
                    schriftelijke toestemming van Oogst.app.
                </p>
                <h2>Artikel 9 Prijzen en betaling</h2>
                <p>
                    1. Alle prijzen zijn exclusief omzetbelasting (btw) weergegeven, tenzij anders overeengekomen.
                    <br/>2. Opdrachtgever is verplicht de kosten van derden, die na goedkeuring van Opdrachtgever door
                    Oogst.app zijn ingezet, volledig te vergoeden tenzij uitdrukkelijk anders overeengekomen.
                    <br/>3. Betaling dient te geschieden binnen de opgegeven betaaltermijn zoals vermeld op de factuur.
                    In geval van te late betaling is Opdrachtgever van rechtswege in verzuim en zal wettelijke rente in
                    rekening worden gebracht.
                </p>
                <h2>Artikel 10 Privacy, gegevensverwerking en beveiliging</h2>

                <p>1. Oogst.app gaat zorgvuldig om met de (persoons)gegevens van Opdrachtgever en gebruikers van de
                    software en zal
                    deze slechts gebruiken conform de geldende wet- en regelgeving, waaronder de Algemene Verordening
                    Gegevensbescherming (AVG).
                    <br/>2. Opdrachtgever is verantwoordelijk voor de verwerking van gegevens die met gebruikmaking van
                    de software
                    van Oogst.app worden verwerkt. Opdrachtgever staat er tevens voor in dat de inhoud van de gegevens
                    niet
                    onrechtmatig is en geen inbreuk maakt op de rechten van derden. Opdrachtgever vrijwaart Oogst.app
                    tegen elke
                    (rechts)vordering die verband houdt met deze gegevens of de uitvoering van de Overeenkomst.
                    <br/>3. Indien Oogst.app op grond van de Overeenkomst dient te voorzien in beveiliging van
                    informatie, zal deze
                    beveiliging voldoen aan de overeengekomen specificaties en een passend beveiligingsniveau bieden,
                    gelet op de
                    stand van de techniek, de gevoeligheid van de gegevens, en de daaraan verbonden kosten.
                </p>
                <h2>Artikel 11 Opschorting en ontbinding</h2>

                <p>1. Oogst.app is gerechtigd om de uitvoering van de dienstverlening geheel of gedeeltelijk op te
                    schorten indien
                    Opdrachtgever niet voldoet aan zijn betalingsverplichtingen of andere verplichtingen voortvloeiend
                    uit de
                    Overeenkomst.
                    <br/>2. In geval van surséance van betaling, faillissement of liquidatie van Opdrachtgever, heeft
                    Oogst.app het
                    recht de Overeenkomst met onmiddellijke ingang te beëindigen, zonder verplichting tot enige
                    schadevergoeding of
                    restitutie.
                </p>
                <h2>Artikel 12 Overmacht</h2>

                <p>1. Oogst.app is niet aansprakelijk wanneer zij ten gevolge van een overmachtssituatie haar
                    verplichtingen op
                    grond van de Overeenkomst niet kan nakomen.
                    <br/>2. Onder overmacht wordt verstaan, naast hetgeen daaromtrent in de wet en jurisprudentie wordt
                    begrepen,
                    alle van buiten komende oorzaken waarop Oogst.app geen invloed kan uitoefenen en waardoor Oogst.app
                    niet in
                    staat is haar verplichtingen na te komen.
                    <br/>3. Indien een overmachtssituatie langer dan twee maanden duurt, hebben beide Partijen het recht
                    de
                    Overeenkomst schriftelijk te ontbinden, zonder dat er sprake is van enige verplichting tot
                    schadevergoeding.
                </p>
                <h2>Artikel 13 Aansprakelijkheid</h2>

                <p>1. De totale aansprakelijkheid van Oogst.app wegens toerekenbare tekortkoming in de nakoming van de
                    Overeenkomst
                    is beperkt tot vergoeding van directe schade tot maximaal het bedrag van de voor die Overeenkomst
                    bedongen prijs
                    (exclusief btw).
                    <br/>2. Oogst.app is niet aansprakelijk voor indirecte schade, waaronder mede begrepen gevolgschade,
                    gederfde
                    winst, gemiste besparingen, en schade door bedrijfsstagnatie.
                    <br/>3. Oogst.app is niet aansprakelijk voor schade die het gevolg is van onjuist of onvolledig
                    gebruik van de
                    software door Opdrachtgever.
                </p>
                <h2>Artikel 14 Intellectuele Eigendomsrechten</h2>

                <p>1. Alle rechten van intellectuele eigendom op de door Oogst.app ontwikkelde en aan Opdrachtgever ter
                    beschikking
                    gestelde software, documentatie, en andere materialen berusten uitsluitend bij Oogst.app.
                    <br/>2. Opdrachtgever verkrijgt uitsluitend een niet-exclusief, niet-overdraagbaar gebruiksrecht van
                    de software
                    voor de duur van de Overeenkomst. Het is Opdrachtgever niet toegestaan om zonder schriftelijke
                    toestemming van
                    Oogst.app enige wijziging aan te brengen in de software.
                    <br/>3. Het is Opdrachtgever verboden om aanduidingen betreffende het vertrouwelijke karakter,
                    auteursrechten,
                    handelsnamen, merken, of enig ander recht van intellectuele eigendom uit de software te verwijderen
                    of te
                    wijzigen.
                </p>
                <h2>Artikel 15 Geheimhouding</h2>

                <p>1. Beide partijen zijn verplicht tot geheimhouding van alle vertrouwelijke informatie die zij in het
                    kader van de
                    Overeenkomst van elkaar of uit andere bron hebben verkregen. Informatie geldt als vertrouwelijk als
                    dit door de
                    andere partij is medegedeeld of als dit voortvloeit uit de aard van de informatie.
                    <br/>2. Indien Oogst.app op grond van een wettelijke bepaling of een gerechtelijke uitspraak
                    gehouden is
                    vertrouwelijke informatie aan door de wet of bevoegde rechter aangewezen derden mede te verstrekken,
                    en
                    Oogst.app zich niet kan beroepen op een verschoningsrecht, dan is Oogst.app niet gehouden tot
                    schadevergoeding
                    of schadeloosstelling.
                </p>
                <h2>Artikel 16 Toepasselijk recht en geschillen</h2>

                <p>1. Op alle rechtsverhoudingen waarbij Oogst.app partij is, is uitsluitend Nederlands recht van
                    toepassing.
                    <br/>2. Geschillen tussen Oogst.app en Opdrachtgever zullen bij uitsluiting worden voorgelegd aan de
                    bevoegde
                    rechter in het arrondissement waarin Oogst.app is gevestigd, tenzij de wet dwingend anders
                    voorschrijft.
                </p>
        </div>

</Card>
</div>
)
    ;
}
